import { render } from "./FolderIcon.vue?vue&type=template&id=6dfc6b49"
import script from "./FolderIcon.vue?vue&type=script&lang=js"
export * from "./FolderIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__